/**
 * 插件页缓存清理（不再写入 sessionStorage / 内存快照）
 * - 标签切换：仅依赖 Layout keep-alive 保留组件实例
 * - 刷新浏览器：应用启动时清除旧版 sessionStorage 残留
 * - 关闭顶部标签：递增 routeCacheVersions 销毁 keep-alive 实例
 */

const LEGACY_SESSION_PREFIX = 'wisdom_plugin_retain_v1_'

/** 关闭菜单标签时，按 shell 路径清理可能存在的旧版 session 键 */
export const SHELL_PATH_RETAIN_CACHE_ID = {
  '/history': '/history',
  '/plan': '/plan',
  '/position': '/position',
  '/fence': '/fence'
}

export function clearAllPluginRetainOnAppStart() {
  purgeLegacyPluginRetainSessionStorage()
}

function purgeLegacyPluginRetainSessionStorage() {
  if (typeof sessionStorage === 'undefined') return
  const keys = []
  for (let i = 0; i < sessionStorage.length; i++) {
    const k = sessionStorage.key(i)
    if (k && k.startsWith(LEGACY_SESSION_PREFIX)) keys.push(k)
  }
  keys.forEach((k) => {
    try {
      sessionStorage.removeItem(k)
      sessionStorage.removeItem(`${k}__invalid`)
    } catch (e) {
      /* ignore */
    }
  })
}

function purgeLegacyKeysContaining(fragment) {
  if (typeof sessionStorage === 'undefined') return
  const frag = fragment != null ? String(fragment).trim() : ''
  if (!frag) return
  const keys = []
  for (let i = 0; i < sessionStorage.length; i++) {
    const k = sessionStorage.key(i)
    if (k && k.startsWith(LEGACY_SESSION_PREFIX) && k.indexOf(frag) !== -1) {
      keys.push(k)
    }
  }
  keys.forEach((k) => {
    try {
      sessionStorage.removeItem(k)
      sessionStorage.removeItem(`${k}__invalid`)
    } catch (e) {
      /* ignore */
    }
  })
}

/** 关闭顶部标签时调用 */
export function invalidatePluginRetainForShellPath(shellFullPath) {
  const raw = shellFullPath != null ? String(shellFullPath).trim() : ''
  if (!raw) return
  const pathOnly = raw.split('?')[0]
  const scope = SHELL_PATH_RETAIN_CACHE_ID[pathOnly]
  if (scope) purgeLegacyKeysContaining(scope)
  if (pathOnly.indexOf('/detail-open') === 0) {
    purgeLegacyKeysContaining(raw)
    purgeLegacyKeysContaining(pathOnly)
  }
  purgeLegacyKeysContaining(pathOnly.replace(/^\//, ''))
}
